import { getHomeTimeline } from '../../../api/timelines/timelines';
import { timelineStoreCreator } from './timeline-store-creator';

export const createHomeTimelineStore = timelineStoreCreator({
  getTimeline: (account, args) => getHomeTimeline(account, args),
  timelineStream: 'user',
});
